import React from "react";

const RatingItemChange = ({
	federationCode,
	currentRating,
	previousRating,
	ratingChange,
	className,
}: {
	federationCode: string;
	currentRating: string;
	previousRating: string;
	ratingChange: string;
	className?: string;
}) => {
	return (
		<div className={`item ratingChange ${className}`}>
			<div className="newRating horizontal">
				<div className="icon" data-federation={federationCode}></div>
				<div className="label">{currentRating}</div>
			</div>
			<div className="oldRating horizontal">
				<div className={`icon ${ratingChange}`}></div>
				<div className="label">from {previousRating}</div>
			</div>
		</div>
	);
};

export default RatingItemChange;
